import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LayoutComponent } from '@plantefeve/common/layout/components/layout/layout.component';
import { LanguageOption } from '@plantefeve/common/layout/models/layout.models';
import { PortalLanguage, PortalLanguageService } from '../language/portal-language.service';
import { NavigationsService } from '../navigations/services/navigations.service';

/** Each language is named in that language, so a user can find their own whatever the portal shows. */
const LANGUAGES: LanguageOption[] = [
  { code: 'nl', label: 'Nederlands' },
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
];

@Component({
  selector: 'igx-root',
  imports: [LayoutComponent, AsyncPipe],
  template: `<igx-layout
    [menu]="(menuItems$ | async) || []"
    [hideSideBar]="true"
    [languages]="languages"
    [currentLanguage]="currentLanguage"
    (languageChange)="switchLanguage($event)"
  ></igx-layout>`,
})
export class RootComponent {
  private readonly _navigationsService = inject(NavigationsService);
  private readonly _languageService = inject(PortalLanguageService);

  public menuItems$ = this._navigationsService.getNavigation();
  public languages = LANGUAGES;
  public currentLanguage = this._languageService.current;

  public switchLanguage(lang: string): void {
    this._languageService.switchTo(lang as PortalLanguage);
  }
}
